import { ReactNode } from "react"

import { Button } from "@/3514/components"
import { buildCssClassName } from "@/3514/utils"

type Props = {
    className?: string
    disabled?: boolean
    children: ReactNode
    onClick: () => void
}
export const BehavioralButton = ({ className, disabled = false, children, onClick }: Props) => {
    return (
        <Button isContainer className={className} onClick={onClick} isDisabled={disabled}>
            <div
                className={buildCssClassName(
                    "behavioral-btn__details d-flex align-items-center",
                    "hover:!border-b-accent",
                    { hover: !disabled }
                )}
            >
                <div className={buildCssClassName("ico ico_plus fs-14", { active: !disabled })}>+</div>
                <span className="d-inline-block ml-1 fs-14">{children}</span>
            </div>
        </Button>
    )
}
